import ClientSelectorComponent from './client-selector-component'

/***
 * A page that prompts a user to selector one or more clients. Once they are selected, a callback function is called
 * that passes back the list of clients.
 */
const clientSelector = angular
    .module('FacilityData.Common.ClientSelector', [])
    .component('clientSelector', ClientSelectorComponent)
    .name;

export default clientSelector;


// WEBPACK FOOTER //
// ./app/common/client-selector/client-selector.js